var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 20,
    viewBox: "0 0 26 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.67268 0.292893C4.28216 -0.0976311 3.64899 -0.0976311 3.25847 0.292893C2.86795 0.683417 2.86795 1.31658 3.25847 1.70711L6.08558 4.53422C5.48764 4.82825 4.92611 5.16017 4.40757 5.52611C2.76231 6.68718 1.51182 8.22472 0.965576 10C1.51182 11.7753 2.76231 13.3128 4.40757 14.4739C6.64683 16.0542 9.68787 17 13 17C14.7093 17 16.3465 16.7481 17.8384 16.2871L21.2585 19.7071C21.649 20.0976 22.2822 20.0976 22.6727 19.7071C23.0632 19.3166 23.0632 18.6834 22.6727 18.2929L19.8682 15.4884C20.4834 15.1888 21.0606 14.8492 21.5925 14.4739C23.2377 13.3128 24.4882 11.7753 25.0345 10C24.4882 8.22472 23.2377 6.68718 21.5925 5.52611C19.3532 3.94585 16.3122 3 13 3C11.2706 3 9.6151 3.25787 8.10906 3.72927L4.67268 0.292893ZM7.59507 6.0437C6.84698 6.35815 6.16388 6.73454 5.56074 7.16018C4.40397 7.97653 3.56825 8.94994 3.10001 10C3.56825 11.0501 4.40397 12.0235 5.56074 12.8398C7.42436 14.155 10.0514 15 13 15C14.1229 15 15.1992 14.8774 16.2044 14.6531L7.59507 6.0437ZM18.3564 13.9766L9.73941 5.35962C10.7607 5.12717 11.8561 5 13 5C15.9486 5 18.5757 5.84502 20.4393 7.16018C21.5961 7.97653 22.4318 8.94994 22.9 10C22.4318 11.0501 21.5961 12.0235 20.4393 12.8398C19.8231 13.2747 19.1235 13.6581 18.3564 13.9766Z",
    fill: "#7C7165"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeClose);
export default __webpack_public_path__ + "static/media/eye-close.d8114b19d6407bbc213ccd758ba42e15.svg";
export { ForwardRef as ReactComponent };